import { render } from "./AuthenticationCard.vue?vue&type=template&id=b70b1cde"
const script = {}

import exportComponent from "/var/www/sostoolkit-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__